import { Card, CardBody, CardTitle, CardText, Row, Col } from 'reactstrap';
import { MdGroups, MdPayments, MdOutlineGroups } from 'react-icons/md';

const CompanyValues = () => {
    return (
        <Row className='my-3'>
            <Col className='mt-2' xs='12' sm='12' md='4' lg='4'>
                <Card>
                    <CardBody>
                        <CardTitle className='d-flex justify-content-center align-items-center' tag="h1"><MdGroups /></CardTitle>
                        <CardText className='text-center bold'><h6>24/7 Service</h6></CardText>
                    </CardBody>
                </Card>
            </Col>
            <Col className='mt-2' xs='12' sm='12' md='4' lg='4'>
                <Card>
                    <CardBody>
                        <CardTitle className='d-flex justify-content-center align-items-center' tag="h1"><MdPayments /></CardTitle>
                        <CardText className='text-center'><h6>Reasonable rates</h6></CardText>
                    </CardBody>
                </Card>
            </Col>
            <Col className='mt-2' xs='12' sm='12' md='4' lg='4'>
                <Card>
                    <CardBody>
                        <CardTitle className='d-flex justify-content-center align-items-center' tag="h1"><MdOutlineGroups /></CardTitle>
                        <CardText className='text-center'><h6>Experienced Teams</h6></CardText>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default CompanyValues;